// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2TFZs","ball":"styles_ball__GxRP7","sticky":"styles_sticky__2cQzG"};